import React, { PropTypes } from 'react';
import partial from 'lodash/partial';
import ConfirmationDialog from 'common/components/modal/confirmation_dialog';

const ReinstateModal = ({ entry, user, reinstate, toggle }) => {
  if (!entry) {
    return null;
  }

  const action = entry.author === user.id? 'un-withdraw' : 'un-eliminate';

  return (
    <ConfirmationDialog
      dialogHeader={`${action} Entry`}
      dialogTitle={`Are you sure you want to ${action} this entry?`}
      dialogMessage='It will be visible again.'
      dialogVisible={true}
      primaryActionText={`Yes, ${action}`}
      toggleDialog={toggle}
      submitAction={partial(reinstate, entry)}
    />
  );
}

ReinstateModal.propTypes = {
  entry: PropTypes.object,
  user: PropTypes.object.isRequired,
  reinstate: PropTypes.func.isRequired,
  toggle: PropTypes.func.isRequired
};

export default ReinstateModal;



// WEBPACK FOOTER //
// ./entries/components/reinstate_modal.jsx